import { RemoteConstants } from '../../data/remote/RemoteConstants';

export async function fetchLogoById(id) {
  try {
    const response = await fetch(`${RemoteConstants.BASE_URL}resources/img/dist/${id}.png`, {
      method: "GET"
    });

    if (response.ok) {
      return response.url;
    } else if (response.status === 404) {
      return null;
    } else {
      throw new Error("Error al cargar el logo");
    }
  } catch (error) {
    throw error;
  }
}

export async function fetchLogoFromLocalStorage(dstId) {
  try {
 const response = await fetch(`${RemoteConstants.BASE_URL}resources/img/dist/${dstId}.png`, {
  method: "GET"
})
    if (response.ok) {
      return response.url;
    } else {
      return null;
    }
  } catch (error) {
    throw error;
  }
}
